import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const SuppliersPage = lazy(() => import("@/pages/suppliers/SuppliersPage"));
const SupplierCreatePage = lazy(() => import("@/pages/suppliers/SupplierCreatePage"));
const SupplierDetailPage = lazy(() => import("@/pages/suppliers/SupplierDetailPage"));

export function SupplierRoutes() {
  return (
    <>
      <Route path="/suppliers" element={<ProtectedRoute><SuppliersPage /></ProtectedRoute>} />
      <Route path="/suppliers/new" element={<ProtectedRoute><SupplierCreatePage /></ProtectedRoute>} />
      <Route path="/suppliers/:id" element={<ProtectedRoute><SupplierDetailPage /></ProtectedRoute>} />
    </>
  );
}
